import { trackedLazy, TrackedSuspense } from '../lib/tracked-lazy';

function universal(load, fallback = <span />) {
  const Cmp = trackedLazy(load);
  return (props) => (
    <TrackedSuspense fallback={fallback}>
      <Cmp {...props} />
    </TrackedSuspense>
  );
}

export { default as AvatarImage } from './AvatarImage';
export const CtaButton = universal(() => import('./CtaButton'));
export const Description = universal(() => import('./Description'));
export const DynamicStat = universal(() => import('./DynamicStat'));
export const ExitIntent = universal(() => import('./ExitIntent'));
export const ExitModal = universal(() => import('./ExitModal'));
export const Link = universal(() => import('./Link'));
export const Markdown = universal(() => import('./Markdown'));
export const Modal = universal(() => import('./Modal'));
export const Stat = universal(() => import('./Stat'));
export const AccordionItem = universal(() => import('./AccordionItem'));
export const FormatRelative = universal(() => import('./FormatRelative'));
export const UpcomingGameButton = universal(
  () => import('./UpcomingGameButton')
);
